import React from "react";
import DragNumberInput from "../ui/DragNumberInput";

function SlideJointPositionOffsetInput({
  disabled,
  editingInputs,
  onChange,
  setEditingInputs,
  value,
}) {
  const inputKey = "slide-position-offset";
  return (
    <div>
      <DragNumberInput
        label="Position Offset From Body Origin"
        value={editingInputs[inputKey] !== undefined ? editingInputs[inputKey] : value}
        dragValue={value}
        disabled={disabled}
        deferDragUpdates={false}
        dragSensitivity={0.01}
        dragSnapStep={0.01}
        onDragValueChange={onChange}
        onChange={(e) => {
          const nextValue = e.target.value;
          setEditingInputs((prev) => ({ ...prev, [inputKey]: nextValue }));
          onChange(nextValue);
        }}
        onFocus={(e) => {
          setEditingInputs((prev) => ({
            ...prev,
            [inputKey]: e.target.value,
          }));
        }}
        onBlur={(e) => {
          const numVal = parseFloat(e.target.value) || 0;
          onChange(numVal);
          setEditingInputs((prev) => {
            const next = { ...prev };
            delete next[inputKey];
            return next;
          });
        }}
        inputClassName="w-full bg-gray-800 border border-gray-600 rounded px-2 py-1 text-gray-100 text-sm"
        inputProps={{
          step: "0.01",
          disabled,
          "aria-label": "Slide joint position offset from body origin",
        }}
        wrapperClassName="space-y-1"
        labelClassName="inline-flex items-center gap-1 text-xs panel-text-helper"
      />
    </div>
  );
}

export default React.memo(SlideJointPositionOffsetInput);
